var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "box" } }, [
    _c("div", { staticClass: "box_bg" }),
    _c(
      "div",
      {
        staticClass: "box_logo",
        on: {
          click: function ($event) {
            return _vm.DigitalCertificate()
          },
        },
      },
      [
        _c("img", {
          staticStyle: {
            width: "68px",
            height: "78px",
            "margin-right": "22px",
          },
          attrs: { src: _vm.httplogo },
        }),
        _c("div", { style: { fontSize: _vm.fontSize + "px" } }, [
          _vm._v(_vm._s(_vm.configdata.projectname)),
        ]),
      ]
    ),
    _c("div", { staticClass: "box_login" }, [
      _c("div", { staticClass: "box_login_title" }, [_vm._v("欢迎登录")]),
      _c(
        "div",
        { staticClass: "box_login_form" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入注册手机号码" },
                      model: {
                        value: _vm.ruleForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "name", $$v)
                        },
                        expression: "ruleForm.name",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-user",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入密码", "show-password": "" },
                      model: {
                        value: _vm.ruleForm.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "password", $$v)
                        },
                        expression: "ruleForm.password",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-lock",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "box_login_button",
                      staticStyle: {
                        background: "#2882FE",
                        "border-color": "#2882FE",
                      },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("立即登录")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "box_tiaozhuan" }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "50%",
                  color: "#2882FE",
                  "text-align": "left",
                },
                on: {
                  click: function ($event) {
                    return _vm.modify()
                  },
                },
              },
              [_vm._v("忘记密码？")]
            ),
            _c(
              "div",
              { staticStyle: { width: "50%", "text-align": "right" } },
              [
                _vm._v("没有账号"),
                _c(
                  "span",
                  {
                    staticStyle: { color: "#2882FE" },
                    on: {
                      click: function ($event) {
                        return _vm.register()
                      },
                    },
                  },
                  [_vm._v("点击注册")]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "box_foot" }, [
      _vm._v("Copyright © 2010-2023 华道艾腾 ALL Rights Reserved 版权所有"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }